<template>
  <v-dialog v-model="dialog" max-width="860">
      <template #activator="{on}">
          <slot v-bind:on="on">
            <v-btn icon v-on="on">
                <v-icon>mdi-package-down</v-icon>
            </v-btn>
          </slot>
      </template>
      <v-card :loading="loading" :disabled="loading">
          <v-card-title>Return product to stock</v-card-title>
          <v-card-text>
              <v-alert v-if="message" :type="messageType">{{message}}</v-alert>
              <v-form ref="returnForm">
                  <v-text-field label="Quantity" type="number" v-model="model.quantity" :rules="[rules.required]" />
                  <warehouse-location v-model="model.location" :rules="[rules.required]" :preferedItems="product.locations" />
                  <v-textarea label="Note" v-model="model.note" :rules="[rules.required]" />
              </v-form>
          </v-card-text>
          <v-card-actions>
                <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import WarehouseLocation from '../forms/autocomplete/WarehouseLocation.vue';
export default {
  components: { WarehouseLocation },
    data:() => ({
        dialog:false,
        model:{},
        loading:false,
        message:null,
        messageType:null,
    }),
    computed:{
        rules: function() {
            return {
                required: value => !!value || "This field is mandatory.",
            };
        },
    },
    props:{
        product:{
            type: Object,
            required: true
        },
        location:{
            type: Object,
        }
    },
    
    mounted(){
        this.model.location = this.location ? this.location.location_id : null
    },
    methods:{
        ...mapActions("productStock", {returnProduct: "update"}),
        close(){
            this.dialog=false;
        },
        save(){
            if (this.$refs.returnForm.validate()) {
                this.loading=true
                this.model.productId=this.product.id;
                this.returnProduct(this.model)
                .then(({success, message}) => {
                    this.loading = false
                    this.message = message
                    this.messageType = success ? "success" : "error"
                    this.$emit("refresh")
                }).catch(({data}) => {
                    const {success, message} = data
                    this.loading = false
                    this.message = message
                    this.messageType = success ? "success" : "error"
                })
            }
        }
    }
}
</script>

<style>

</style>